import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import dateFormatService from '@/shared/services/DateFormatService';
import messages from './taskMessages';
import { injectStateService } from '@/shared/services/StateService';
import { injectIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';

const authorizationMissingStatus = 1;
const authorizationExpiringStatus = 2;
const authorizationExpiredStatus = 3;

const labelForStatus = (intl, authorizationType, status, expiryDate) => {
  if (status === authorizationMissingStatus) {
    return intl.formatMessage(messages.RequiredAuthorizationMissing, {
      authorization: intl.formatMessage(listItemMsg('authorizationName', authorizationType)),
    });
  }

  if (status === authorizationExpiringStatus) {
    return intl.formatMessage(messages.RequiredAuthorizationExpiring, {
      authorization: intl.formatMessage(listItemMsg('authorizationName', authorizationType)),
      expiryDate: expiryDate ? dateFormatService.formatDate(expiryDate) : null,
    });
  }
  if (status === authorizationExpiredStatus) {
    return intl.formatMessage(messages.RequiredAuthorizationExpired, {
      authorization: intl.formatMessage(listItemMsg('authorizationName', authorizationType)),
      expiryDate: expiryDate ? dateFormatService.formatDate(expiryDate) : null,
    });
  }
};

const TaskRequiredAuthorizationsIcon = ({
  stateService,
  relationId,
  taskId,
  intl,
  requiredAuthorizations,
}) =>
  requiredAuthorizations?.length > 0 ? (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`task-required-authorization-warning${taskId}`}>
          {requiredAuthorizations.map(requiredAuthorization => (
            <div>
              {labelForStatus(
                intl,
                requiredAuthorization.authorizationType,
                requiredAuthorization.status,
                requiredAuthorization.expiryDate,
              )}
            </div>
          ))}
        </Tooltip>
      }
    >
      <a
        onClick={() =>
          stateService.gotoRelation(relationId, {
            gotoField: '3d6de6a8-b4f2-428a-a8f5-c5ee2467c913',
          })
        }
      >
        <i className="fa fa-exclamation-triangle fa-fw text-danger" />
      </a>
    </OverlayTrigger>
  ) : null;

export default injectIntl(injectStateService(TaskRequiredAuthorizationsIcon));
